import { createSlice } from '@reduxjs/toolkit';

const branchSlice = createSlice({
  name: 'branch',
  initialState: {
    list: [],
  },
  reducers: {
    setBranches: (state, action) => {
      state.list = action.payload;
    },
    addBranch: (state, action) => {
      state.list.push(action.payload);
    },
    updateBranch: (state, action) => {
      const index = state.list.findIndex(branch => branch._id === action.payload._id);
      if (index !== -1) {
        state.list[index] = action.payload;
      }
    },
    clearBranches: (state) => {
      state.list = [];
    },
 
deleteBranch: (state, action) => {
  state.list = state.list.filter(branch => branch._id !== action.payload);
}

  },
});

export const {
  setBranches,
  addBranch,
  updateBranch,
  clearBranches,
  deleteBranch
} = branchSlice.actions;

export default branchSlice.reducer;
